import { Component } from '@angular/core';
@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
})
export class LogoutComponent {
    title = 'Cierre de sesión';
    description = 'Por razones de seguridad, cierre su navegador';
}
